import React from 'react'

// Marketplace button primitive.
// Variants: primary | secondary | ghost | danger | outline
// Sizes:    sm | md | lg
//
// No business logic. Forwards all native button props.
// Usage:
//   <Button>Səbətə əlavə et</Button>
//   <Button variant='outline' size='sm'>Hamısına bax</Button>
//   <Button as='a' href='/market'>Bazara keç</Button>

const VARIANT = {
  primary:   'bg-brand-600 text-white hover:bg-brand-700 disabled:bg-brand-300 shadow-card',
  secondary: 'bg-brand-50 text-brand-700 hover:bg-brand-100 disabled:opacity-60',
  ghost:     'bg-transparent text-slate-700 hover:bg-slate-100 disabled:opacity-60',
  outline:   'bg-white text-slate-800 border border-slate-200 hover:border-brand-500 hover:text-brand-700 disabled:opacity-60',
  danger:    'bg-danger-600 text-white hover:bg-danger-700 disabled:opacity-60',
  accent:    'bg-accent-500 text-white hover:bg-accent-600 disabled:opacity-60 shadow-card',
}

const SIZE = {
  sm: 'h-9  px-3 text-xs   rounded-card gap-1.5',
  md: 'h-11 px-5 text-sm   rounded-card gap-2',
  lg: 'h-12 px-6 text-base rounded-card gap-2',
}

const Button = React.forwardRef(function Button(
  {
    as: Tag = 'button',
    variant = 'primary',
    size = 'md',
    block = false,
    leftIcon,
    rightIcon,
    className = '',
    children,
    type,
    ...rest
  },
  ref
) {
  const base = 'inline-flex items-center justify-center font-semibold transition-all duration-150 select-none focus:outline-none focus-visible:shadow-ring disabled:cursor-not-allowed'
  const cls = [
    base,
    VARIANT[variant] || VARIANT.primary,
    SIZE[size] || SIZE.md,
    block ? 'w-full' : '',
    className,
  ].join(' ')

  const finalType = Tag === 'button' ? (type || 'button') : type

  return (
    <Tag ref={ref} className={cls} type={finalType} {...rest}>
      {leftIcon && <span className='inline-flex shrink-0'>{leftIcon}</span>}
      <span className='inline-flex items-center'>{children}</span>
      {rightIcon && <span className='inline-flex shrink-0'>{rightIcon}</span>}
    </Tag>
  )
})

export default Button
